import React from 'react';
import Banner from './banner';
import FeatureNew from './feature-new';
import Slide1 from './slide1';
import Slide3 from './slide3';
import Slide4 from './slide4';
import Slide5 from './slide5';
import Slide6 from './slide6';
import Technologygcc from './technologygcc';
import Cutttingedge from "./cutttingedge";
import Servicesweb from './servicesweb';
import Topgradecta from './topgradecta';
import Techstacklp from './techstacklp';
import Workflow from "./workflow";
import Associatesslider from "./associatesslider";
import EbookLanding from './ebook';
import FooterLanding from './footer';
import Sidebtns from './sidebtns';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel} from 'swiper/modules';

const Sliders = () => {
  return (
    <div className='Sliders'>

      <Swiper
        direction="vertical"
        spaceBetween={0}
        mousewheel={true}
        style={{ height: '100vh' }}
        modules={[Mousewheel]}
      >
        <SwiperSlide>
          <Banner />
        </SwiperSlide>
        <SwiperSlide>
          <FeatureNew />
        </SwiperSlide>
        <SwiperSlide>
          <Slide1 />
        </SwiperSlide>
        <SwiperSlide>
          <Slide4 />
        </SwiperSlide>
        <SwiperSlide>
          <Slide3 />
        </SwiperSlide>
        <SwiperSlide>
          <Technologygcc />
        </SwiperSlide>
        <SwiperSlide>
          <Cutttingedge />
        </SwiperSlide>
        <SwiperSlide>
          <Servicesweb />
        </SwiperSlide>
        <SwiperSlide>
          <Topgradecta />
        </SwiperSlide>
        <SwiperSlide>
          <Slide5 />
        </SwiperSlide>
        <SwiperSlide>
          <Slide6 />
        </SwiperSlide>
        <SwiperSlide>
          <Techstacklp />
        </SwiperSlide>
        <SwiperSlide>
          <Workflow />
        </SwiperSlide>
        <SwiperSlide>
          <Associatesslider />
        </SwiperSlide>
        <SwiperSlide>
          <EbookLanding />
        </SwiperSlide>
        <SwiperSlide>
          <FooterLanding />
          <Sidebtns />
        </SwiperSlide>
      </Swiper>
    </div>
  )
}

export default Sliders